var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f0f0f0;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M9.835,10.966,5.6,6.731,1.366,10.966A.8.8,0,1,1,.234,9.835L4.469,5.6.234,1.366A.8.8,0,0,1,1.366.234L5.6,4.469,9.835.234a.8.8,0,1,1,1.131,1.131L6.731,5.6l4.234,4.234a.8.8,0,0,1-1.131,1.131Z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-1",
    cx: 12,
    cy: 12,
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(6.4 6.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M9.835,10.966,5.6,6.731,1.366,10.966A.8.8,0,1,1,.234,9.835L4.469,5.6.234,1.366A.8.8,0,0,1,1.366.234L5.6,4.469,9.835.234a.8.8,0,1,1,1.131,1.131L6.731,5.6l4.234,4.234a.8.8,0,0,1-1.131,1.131Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x-2",
    "data-name": "x",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COLOR_black",
    "data-name": "COLOR/ black",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 19.2,
    height: 19.2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.49945914.svg";
export { ForwardRef as ReactComponent };